import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'obc-btns-cartao',
  templateUrl: './modal-btns.component.html',
  styleUrls: ['./modal-btns.component.scss'],
})
export class ModalBtnsComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { titulo: string; mensagem: string; textoBtnPrimario: string; textoBtnSecundario: string },
    private bottomSheetRef: MatBottomSheetRef<ModalBtnsComponent>
  ) {}

  fecharModal() {
    this.bottomSheetRef.dismiss(false);
  }

  confirmarModal() {
    this.bottomSheetRef.dismiss(true);
  }
}
